import { Injectable } from '@angular/core';
import {
   CanActivate,
   ActivatedRouteSnapshot,
   UrlTree,
   Router,
   RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
/**
 * Guard is used to secure routes on client side so if a student tries to have access on professor route the auth guard will not activate requested guard
 */
@Injectable({
   providedIn: 'root',
})
export class AuthGuard implements CanActivate {
   /**
    * Class constructor
    * @param authServiceService
    * @param router
    */
   constructor(
      private authServiceService: AuthService,
      private router: Router
   ) {}
   /**
    * Method used to check if the path can be activated upon specific conditions.
    */
   canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
   ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = route.params['token'];
      const clientName = route.params['clientName'];
      const submissionId = route.params['submissionId'];
      const id = route.params['id'];
      const expanded = route.queryParams['expanded'];
      const editParameter = route.queryParams['edit'];
      const sessionId = route.queryParams['sessionId'];

      if (token) {
        localStorage.setItem('ACCESS_TOKEN', JSON.stringify(token));
        let urlToReturn = '';
        if (clientName) {
          urlToReturn = `/report/${clientName}/${submissionId}`;
        } else {
          urlToReturn = `/submission/${id}/report/v2`;
        }

        if (expanded) {
          urlToReturn += `?expanded=${expanded}`;
        }

        if (editParameter) {
          urlToReturn += urlToReturn.includes('?') ? `&edit=${editParameter}` : `?edit=${editParameter}`;
        }

        if (sessionId) {
          urlToReturn += urlToReturn.includes('?') ? `&sessionId=${sessionId}` : `?sessionId=${sessionId}`;
        }

        return this.router.parseUrl(urlToReturn);
      }

      return this.router.parseUrl('/not-found');
   }

}
